/**
 * 주문 상태 상수
 * API 명세 기준
 */

export const ORDER_STATUS = {
  PENDING: 'pending',
  WAITING: 'waiting',
  APPROVED: 'approved',
  PAID: 'paid',
  REJECTED: 'rejected',
  PREPARING: 'preparing',
  COMPLETED: 'completed',
  PICKED_UP: 'picked_up',
  CANCELLED: 'cancelled',
};

export const STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: '대기',
  [ORDER_STATUS.WAITING]: '대기요청',
  [ORDER_STATUS.APPROVED]: '승인',
  [ORDER_STATUS.PAID]: '결제',
  [ORDER_STATUS.REJECTED]: '거절',
  [ORDER_STATUS.PREPARING]: '조제',
  [ORDER_STATUS.COMPLETED]: '완료',
  [ORDER_STATUS.PICKED_UP]: '픽업',
  [ORDER_STATUS.CANCELLED]: '취소',
};

export const STATUS_COLORS = {
  [ORDER_STATUS.PENDING]: '#FF9800',
  [ORDER_STATUS.WAITING]: '#C254FE',
  [ORDER_STATUS.APPROVED]: '#2196F3',
  [ORDER_STATUS.PAID]: '#00BCD4',
  [ORDER_STATUS.REJECTED]: '#F44336',
  [ORDER_STATUS.PREPARING]: '#9C27B0',
  [ORDER_STATUS.COMPLETED]: '#4CAF50',
  [ORDER_STATUS.PICKED_UP]: '#9E9E9E',
  [ORDER_STATUS.CANCELLED]: '#9E9E9E',
};
